<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 style="float:left;">Listings</h1>
                  </div>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Service</th>
                      <th scope="col">Price</th>
                      <th class="hidden-sm" scope="col">Date Listed</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="{'row-warning':!listing.paid && listing.price != 'free'}"  v-for="listing in store.state.listings" :key="listing.id">
                      <td>{{listing.first_name}} {{listing.last_name}}</td>
                      <td>{{listing.service}}</td>
                      <td>{{listing.price}}</td>
                      <td class="hidden-sm">{{dateListed(listing)}}</td>
                      <td>
                        <button @click="moreInfo(listing)" class="btn btn-primary btn-blue">More Info</button>
                        <button v-if="listing.removed == 0" @click="remove(listing)" class="btn btn-primary btn-orange">Remove</button>
                        <span v-else>Removed</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminListingsStore from './AdminListingsStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'
import moment from 'moment'

export default {
  name: 'AdminListings',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminListingsStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      
      this.getListings();
    },(err) => {
      this.nav.goAdminLogin(this);
    })
  },
  methods: {
    getListings: function() {
      let self = this
      this.store.getListings((data) => {
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    dateListed: function(listing) {
      return moment(listing.dateListed).format("MM/DD/YYYY")
    },
    moreInfo: function(listing) {
      this.nav.goAdminListing(this,listing.id)
    },
    remove: function(listing) {
      this.store.removeListing(listing.id,() => {
        this.getListings()
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row-warning {
background:#fbe296 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminListings.vue